import React from 'react'
import {Route, Switch} from 'react-router-dom'

import {routes} from './routerConfig'

const FooterRouter = () => {
  return <Route render={({location}) => (
    <Switch location={location} key={location.pathname}>
      {routes.map(route =>
        <Route key={route.key} path={route.path} children={route.footer ? <route.footer/> : <></>} exact={route.exact} />
      )}
    </Switch>
  )}/>
}

export default FooterRouter
